import { SchemaMetl } from '@frontend/schema';

export const queryKeys = {
  base: 'messages',
  fullSyncLocation: () => [queryKeys.base, 'fullSyncLocation'],
};

export const useFullSyncLocation = () => SchemaMetl.FullSyncLocation({});
